/* eslint-disable no-unused-labels */
export const darkTheme = {
  bg: "black",
  bgLi: "#202020",
  text: "white",
  textSof: "#aaaaaa",
};

export const lightTheme = {
  bg: "linear-gradient(90deg, rgba(9,103,121,1) 3%, rgba(180,111,130,1) 100%)",
  bgLi: "white",
  text: "black",
  textSof: "#606060",
};
